
<p-inc-mail-menu-content
    :items         = "units"
    :selected-item = "selected"
    item-label     = "Anlage"
    item-text      = "fabricNo"
    :width         = "500"
    @search        = "onSearch"
    @selected      = "onUnit"
>
    <template v-slot:item="{ item }">
        <div class="v-flex">
            <div style="width: 100px;">
                {{ item.fabricNo }}
            </div>
        </div>
        <div>
            {{ unitAsString(item) }}
        </div>
    </template>
    <template v-slot:selection="{ item }">
        {{ item.fabricNo }} - {{ unitAsString(item) }}
    </template>

    <template v-slot:content>
        <div class="pa-3 pl-4 pr-1">
            <div class="mt-1">
                <p-inc-selectable-document
                    v-for     = "(document,index) in filteredDocuments"
                    :key      = "index"
                    :document = "document"
                    class     = "border-style"
                    :class    = "border(index)"
                    :selected = "isSelected(document)"
                    @selected = "onSelected"
                />
            </div>
        </div>
        <div v-if="!filteredDocuments || filteredDocuments.length === 0" class="mail-empty-documents error--text">
            {{ empty }}
        </div>
    </template>
</p-inc-mail-menu-content>
